import React, { useState } from 'react';
import './HomePage.css';
import axios from "axios";
import logo from '../assets/logo.jpg';
import Contact from './contactus';
import AboutUs from './aboutus';
import Milestones from './milestones';
import Gallery from './gallery';
import Leadership from './leadership';
import Events from './events';


const baseUrl = process.env.REACT_APP_API_BASE_URL;

console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL);


const districts = [
  "Thiruvananthapuram", "Kollam", "Pathanamthitta", "Alappuzha", "Kottayam", "Idukki",
  "Ernakulam", "Thrissur", "Palakkad", "Malappuram", "Kozhikode", "Wayanad", "Kannur", "Kasaragod"
];

const HomePage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    address: '',
    district: '',
    place: '',
    phone: '',
  });
  const [ageError, setAgeError] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    if (e.target.name === 'age' && (e.target.value < 6 || e.target.value > 18)) {
      setAgeError('Age must be between 6 and 18');
    } else {
      setAgeError('');
    }

    if (e.target.name === 'phone' && !/^\d{10}$/.test(e.target.value)) {
      setPhoneError('Phone number must be 10 digits');
    } else {
      setPhoneError('');
    }
  };

  const handleSubmit = async () => {
    console.log("Submitting form with data:", formData); // Debug log

    // Validate required fields
    for (const key in formData) {
      if (!formData[key].trim()) {
        alert(`Please fill in the ${key} field.`);
        return;
      }
    }

    // Validate age
    if (parseInt(formData.age, 10) >= 19) {
      setAgeError("Only children below 18 years are allowed to register.");
      return;
    }
    setAgeError("");

    // Validate phone number
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      setPhoneError("Phone number must be exactly 10 digits and contain only numbers.");
      return;
    }
    setPhoneError("");

    try {
      axios.post(`${baseUrl}/members/join`, formData)
      console.log("baseUrl is:", baseUrl);
      console.log("Final URL:", `${baseUrl}/members/join`);


      // Reset form fields after successful submission
      setFormData({
        name: "",
        phone: "",
        age: "",
        address: "",
        district: "",
        place: "",
      });
      setAgeError("");
      setPhoneError("");


      setShowPopup(false);
      setShowSuccess(true);
    } catch (error) {
      console.error("Error submitting form:", error);
      setShowFailure(true);
    }
  };


  return (
    <div>
      <nav className="navbar">
        <div className="nav-logo">
          <img src={logo} alt="KidZone Logo" className="logo-image" />
        </div>
        <div className="nav-header">
          <h3>AKHILA KERALA BALAJANA SAKHYAM</h3>
        </div>
        <ul className="nav-links">
          <li><a href="#home-page">Home</a></li>
          <li><a href="#milestones">Milestones</a></li>
          <li><a href="#leadership">Leadership</a></li>
          <li><a href="#events">Events</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#contact">Contact Us</a></li>
        </ul>
      </nav>

      <div className="home-page" id='home-page'>
        <div className="comic-text">
          <h2>അഖില കേരള ബാലജന സഖ്യം</h2>
          <div className="btn-container">
            <button className="btn-learn" onClick={() => document.getElementById('milestones')?.scrollIntoView({ behavior: 'smooth' })}>
              Learn More
            </button>
            <button className="btn-join" onClick={() => setShowPopup(true)}>Join Us</button>
          </div>
        </div>
      </div>

      <div id="milestones"><Milestones /></div>
      <div id="leadership"><Leadership /></div>
      <div id="events"><Events /></div>
      <div id="gallery"><Gallery /></div>
      <div id="about"><AboutUs /></div>
      <div id="contact"><Contact /></div>

      {showPopup && (
        <div className="popup">
          <div className="popup-overlay">
            <div className="popup-content">
              <div className="popup-header">
                <h3>Join Us</h3>
                <img src={logo} alt="Logo" className="popup-logo" />
              </div>

              <label>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label>Age:</label>
              <input
                type="number"
                name="age"
                value={formData.age}
                onChange={handleChange}
                required
              />
              {ageError && <p className="error-message">{ageError}</p>}

              <label>Address:</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              ></textarea>

              <label>District:</label>
              <select
                name="district"
                value={formData.district}
                onChange={handleChange}
                required
              >
                <option value="">Select District</option>
                {districts.map((district, index) => (
                  <option key={index} value={district}>
                    {district}
                  </option>
                ))}
              </select>

              <label>Place:</label>
              <input
                type="text"
                name="place"
                value={formData.place}
                onChange={handleChange}
                required
              />

              <label>Phone:</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              {phoneError && <p className="error-message">{phoneError}</p>}

              <div className="button-group">
                <button className="ok-button" onClick={handleSubmit}>Submit</button>
                <button className="cancel-button" onClick={() => setShowPopup(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSuccess && (
        <div className="success-modal">
          <div className="success-content">
            <p>Successfully Registered!</p>
            <button className="ok-button" onClick={() => setShowSuccess(false)}>OK</button>
          </div>
        </div>
      )}

      {showFailure && (
        <div className="success-modal">
          <div className="success-content">
            <p>Registration Failed!</p>
            <button className="cancel-button" onClick={() => setShowFailure(false)}>OK</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default HomePage;
